import React from "react";
import "./Footer.css";
const Footer = () => {
  return <footer>Powered By M.A. Technology™</footer>;
};

export default Footer;
